export const APP_FILE_LIST_SECURITY_GROUPS = "/list-security-groups";
